import React, { useContext } from "react";

import { DiscoveryContext } from "../discovery-context";

import SourceTableView from "./SourceTableView";
import { Card } from "@mui/material";

function filterUniqueDomains(urls) {
  const domainMap = new Map();

  urls.forEach((url) => {
    try {
      const parsedUrl = new URL(url);
      const fullDomain = parsedUrl.hostname;
      const parts = fullDomain.split(".");
      const mainDomain = parts.slice(-2).join(".");

      if (!domainMap.has(mainDomain)) {
        domainMap.set(mainDomain, { src: fullDomain, items: [], urls: [] });
      }

      const domainEntry = domainMap.get(mainDomain);

      if (!domainEntry.urls.includes(url)) {
        domainEntry.urls.push(url);
      }

      if (
        fullDomain !== mainDomain &&
        !domainEntry.items.some((item) => item.src === fullDomain)
      ) {
        domainEntry.items.push({ src: fullDomain, urls: [url] });
      } else {
        const subdomainEntry = domainEntry.items.find(
          (item) => item.src === fullDomain
        );
        if (subdomainEntry && !subdomainEntry.urls.includes(url)) {
          subdomainEntry.urls.push(url);
        }
      }
    } catch (error) {
      console.error("Invalid URL:", url);
    }
  });

  return Array.from(domainMap.values()).map((domain) => ({
    src: domain.src,
    urls: domain.urls,
    ...(domain.items.length > 0 ? { items: domain.items } : {}),
  }));
}

export default function Sources() {
  const discoveryCtx = useContext(DiscoveryContext);

  const sources = filterUniqueDomains(discoveryCtx.sources);

  return (
    <>
      {sources.length > 0 && (
        <Card>
          <SourceTableView data={sources} llm={discoveryCtx.llm} />
        </Card>
      )}
    </>
  );
}
